
import { Category } from "@/script/apps/cms/entity/CmsEntity";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { CategoryService } from "@/script/apps/cms/service/CategoryService";
import { CallBack } from "@/script/core/service/DataService";
import { ElMessage } from "element-plus";

@Options({})
export default class CategoryRefer extends BaseList {
  private queryEntity: Category = {};

  private dataList: Category[] = [];

  private service = new CategoryService();

  private dialogVisible = false;

  private callBack: CallBack<Category> | null = null;

  private currentRow: Category | null = null;

  public initData(): ServiceContext {
    this.queryParam.pager = {
      pageIndex: 1,
      pageSize: 1000,
      total: 0,
      sorters: [{ prop: "sortNo", sortField: "cc.sort_no", sortMode: "desc" }],
    };
    return ServiceFactory.build(
      "biz_cms_category",
      "/cms/category",
      "/cms/category",
      this.service
    );
  }

  public initQueryEntity() {
    this.queryEntity = {
      code: "",
      name: "",
    };
    return this.queryEntity;
  }

  public afterLoadList(data: any): void {
    const dataList: Category[] = data.list as Category[];
    dataList.forEach((item) => {
      item.staticizeName = item.staticize ? "是" : "否";
      item.navName = item.nav ? "是" : "否";
    });

    const dataTree: Category[] = [];
    dataList.forEach((item) => {
      if (!item.parentId) {
        item.childCategorys = [];
        dataTree.push(item);
        this.generateTree(dataList, item);
      }
    });
    this.dataList = dataTree;
    if (this.$refs.tableRefer) {
      (this.$refs.tableRefer as any).setCurrentRow();
    }
  }

  private generateTree(dataList: Category[], parent: Category) {
    const childs: Category[] = [];
    dataList.forEach((item) => {
      if (item.parentId === parent.id) {
        childs.push(item);
        // 递归
        this.generateTree(dataList, item);
      }
    });
    if (childs.length > 0) {
      parent.childCategorys = childs;
    }
  }

  handleCurrentChange(row: Category) {
    this.currentRow = row;
  }

  public show(callBack: CallBack<Category>) {
    this.currentRow = null;
    this.callBack = callBack;
    this.dialogVisible = true;
  }

  private opened() {
    if (this.$refs.tableRefer) {
      (this.$refs.tableRefer as any).setCurrentRow();
    }
  }

  confirm() {
    if (this.currentRow === null) {
      ElMessage.error("请选择栏目！");
      return;
    }
    this.dialogVisible = false;
    if (this.callBack) {
      this.callBack(this.currentRow!);
    }
  }
}
